export default {}
let baseUrl = ''
if (process.env.NODE_ENV === 'production') {
    baseUrl = 'https://api.qualityobserver.24apps.it/api'
} else {
    baseUrl = 'https://api.internalghost.local/api'
}
export const API_URL = baseUrl
